/**
 * Scripts for run-reports panel
 *
 * @author Lukasz Lewandowski <llewandowski@rippleffect.com>
 */
admin.registerLoad(function (prefix) {
    // Check if run-reports page is loaded
    if ($(prefix + ".list-reports-run-reports")[0]) {
        // Reload page every 30s to check if new reports were generated
        setInterval(function() {
            window.location.reload();
        }, 30000);
    }
});
